export const DEFAULT_INTERVAL_VALUE = 1000;
export const AMOUNT_CHANGE_CONTENT = 'XXXX';
export const BUSINESS = 'BUSINESS';
export const PERSON = 'PERSON';
export const taxIdRegex = /\d{2}[- ]\d{6}/;
export const nitIdRegex = /\d{11}[- ]?\d{1}/;
export const onlyTextRegex = /^[A-Za-zÀ-ÿ ]*$/g;
export const anyTextRegex = /^[A-Za-zÀ-ÿ0-9 ]*$/g;
export const onlyNumbersAndLettersRegex = /^[A-Za-zÀ-ÿ0-9]*$/g;
export const onlyNumbersRegex = /^\d+$/;
export const textRegex = /\S/;
